import { fmhNpiAPI, POLICY_API_URL } from 'api/APIBase';

export async function getQuestionTree({ productServiceOid, diagnosisOid, payerId, prescriberNpi }) {
    const url = `${POLICY_API_URL}/${payerId}/policies/${productServiceOid}/${diagnosisOid}`;
    const data = await fmhNpiAPI({ url, npi: prescriberNpi }).get().json();
    return JSON.parse(data.graph);
}
